import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "box-filter-component",
  templateUrl: "./box-filter-component.component.html",
  styleUrls: ["./box-filter-component.component.scss"],
})
export class BoxFilterComponentComponent implements OnInit {
  @Input("listaFiltro") listaFiltro: any[];
  @Output() filtrar = new EventEmitter();
 
  constructor() {}

  ngOnInit() {
    console.log(this.listaFiltro)
  }

  limparFiltro(field, filtro?) {
    if (field === "termo") {
      this.listaFiltro = this.listaFiltro.filter(
        (f) => f !== filtro
      );
    }

    if (field === "todosTermos") {
      this.listaFiltro = [];
    }

    this.filtrar.emit(["box-filter", this.listaFiltro]);
  }
}
